<!--
 * @author: JJ
 * @since: 2024-10-09
 * headerSearch.vue
-->
<template>
    <div class="search_fixed">
        <div class="w1440 flex-box h150">
            <img src="../assets/static/images/jj_logo_new.png" class="logo cursor" @click="toIndex" alt="">
            <div class="pl75 flex-grow-1">
                <div class="flex-box pt20">
                    <div class="search_nav flex-grow-1 flex-box fs16 ">
                        <img src="../assets/static/icon/jj_search.png" class="ico32" alt="">
                        <input type="text" class="flex-grow-1 plr10  col04" v-model="keyword"
                            placeholder="请输入您想搜索的商品名或生产厂家" @keyup.enter="searchGoods">
                        <div class="btn_search cursor" @click="searchGoods">搜索商品</div>
                    </div>
                    <router-link class="cart_nav flex-center fs16 col4b" to="/Cart">
                        <img src="../assets/static/icon/jj_head_cart.png" class="ico32" alt="" ref="myElement">
                        <div class="pl15">我的购物车</div>
                        <span class="dot" v-if="cartCount > 0">{{ cartCount > 99 ? '99+' : cartCount }}</span>
                    </router-link>
                </div>
                <div class="pl20 pt10 flex-box ul_box fs14">
                    <div @click="clickKeyword(item.keyword)" v-for="(item, index) in hotSearch" class="ui  cursor"
                        :class="index == 0 ? 'ac' : ''" :key="index">{{ item.keyword }}</div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
export default {
    data() {
        return {
            hotSearch: [],
            keyword: '',
            cartCount: 0,
            position: {
                x: 0, y: 0
            }
        }
    },
    methods: {
        //获取热门搜索
        hotSearchList() {
            this.$api.HotSearch().then(ret => {
                this.hotSearch = ret.data;
            })
        },
        clickKeyword(keyword) {
            this.keyword = keyword;
            this.searchGoods();
        },
        searchGoods() {
            this.$router.push({ path: '/FindProduct', query: { keyword: this.keyword } })
        },
        toIndex() {
            this.$router.push('/')
        },
        getElementPosition() {
            const element = this.$refs.myElement; // 获取元素
            const rect = element.getBoundingClientRect(); // 获取元素的位置信息
            return {
                x: rect.left,
                y: rect.top,
            }
        }
    },
    mounted() {
        let that = this;
        this.$bus.on("cartRefresh", function () {
            that.$api.CartCount().then(ret => {
                that.cartCount = ret.data;
            })
        })
    },
    created() {
        // 产品id
        this.keyword = this.$route.query.keyword || '';
        this.hotSearchList();
        if (this.$cookies.get("token")) {
            this.$api.CartCount().then(ret => {
                this.cartCount = ret.data;
            })
        }
    },
    beforeUnmount() {
        this.$bus.off('cartRefresh');
    },
}
</script>
<style lang="less" scoped>
.h150 {
    height: 150px;
}

.search_fixed {
    height: 150px;
    width: 100%;
    position: relative;
    z-index: 99;
    background: #F9F9F9;

    .logo {
        width: 170px;
        height: auto;
        margin-bottom: 10px;
        margin-left: 30px;
    }

    .pl75 {
        padding-left: 55px;
    }

    .search_nav {
       
        height: 56px;
        border-radius: 8px;
        border: 2px solid #3D7EFE;
        padding-left: 18px;
        padding-right: 8px;
    }

    .ico32 {
        width: 32px;
        height: auto;
    }

    .btn_search {
        width: 110px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        color: #FFFFFF;
        background: #3D7EFE;
        border-radius: 8px;
    }

    .ui {
        margin-right: 44px;
        color: #7998BE;

        &.ac {
            color: #3D7EFE;
        }
    }
}

.cart_nav {
    margin-left: 24px;
    width: 200px;
    height: 56px;
    border-radius: 8px;
    border: 2px solid #3D7EFE;
    display: inline-flex;
    align-items: center;
    position: relative;

    .dot {
        min-width: 20px;
        line-height: 20px;
        border-radius: 100px;
        position: absolute;
        top: 2px;
        right: 5px;
        background: red;
        color: #FFFFFF;
        font-size: 10px;
        text-align: center;
        padding: 0 5px;
    }
}

.col4b {
    color: #4B4B4B;
}

.ul_box {
    height: 30px;
}
</style>
